import { getEnv } from '@src/apis/shared';

export const FEATURE_STOREFRONT_THEME_ENABLED = 'FEATURE_STOREFRONT_THEME_ENABLED';

/**
 * Runtime dark-launch / kill-switch for the storefront-theme feature. Read from env.js (window) via
 * getEnv rather than build-time process.env, so a per-env flip takes effect on redeploy without a
 * rebuild. This is combined with the per-partner `CanAccess` permission gate on the route and menu
 * item — BOTH must pass for the feature to surface. Per-partner rollout is the permission (runtime);
 * this flag is the per-env on/off.
 */
export const isStorefrontThemeEnabled = (): boolean =>
  getEnv(FEATURE_STOREFRONT_THEME_ENABLED) === 'true';
